import { useEffect } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useQuery } from '../../../pmui/transactions/Transactions';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPricingQuote, selectOnboardingApplicationState } from '../../../pmui/onboarding/sagas/pmonboardingSlice';
import PricingQuoteMonthlyFeesTable from './PricingQuoteMonthlyFeesTable';
import PricingQuoteConsumablesTable from './PricingQuoteConsumablesTable';
import PricingQuoteSummaryCard from './PricingQuoteSummaryCard';
import PricingQuoteFootNotes from './PricingQuoteFootNotes';
import { useHistory } from 'react-router';

const ViewQuote = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const quoteUuid = query.get('quoteUuid') || '';
  const history = useHistory();
  const { fetchPricingQuoteResponse } = useSelector(selectOnboardingApplicationState);
  const thisQuoteDiscount = fetchPricingQuoteResponse?.DetailsPayload?.SelectedPackageDiscount;
  const includedProductsInThisQuote = fetchPricingQuoteResponse?.DetailsPayload?.IncludedProducts;

  //useEffects
  useEffect(() => {
    if (quoteUuid) {
      dispatch({
        type: fetchPricingQuote.type,
        payload: { pricingQuoteUuid: quoteUuid },
      });
    }
  }, [quoteUuid]);

  return (
    <Box sx={{ padding: 4 }}>
      <Grid container columnSpacing={10} rowSpacing={10}>
        {/* Left Section */}
        <Grid item xs={12} md={6}>
          <Typography sx={{ fontFamily: 'Work Sans !important', fontWeight: 'bold', fontSize: '20px', mb: 2 }}>Packages, Products, & Monthly Fees</Typography>
          <PricingQuoteMonthlyFeesTable includedProducts={includedProductsInThisQuote || []} packageDiscount={thisQuoteDiscount || 0} />
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={6}>
          <PricingQuoteSummaryCard
            includedProducts={includedProductsInThisQuote || []}
            packageDiscount={thisQuoteDiscount || 0}
            buttonText="Get Started with Inosio"
            onButtonClick={() => {
              history.push('/onboarding/basiccompanyinfo');
            }}
          />
        </Grid>
      </Grid>

      <Grid container rowSpacing={5}>
        <Grid item xs={12}>
          <Typography sx={{ fontFamily: 'Work Sans !important', fontWeight: 'bold', fontSize: '20px', mt: 4, mb: 2 }}>Consumables</Typography>
          <PricingQuoteConsumablesTable includedProducts={includedProductsInThisQuote || []} />
        </Grid>
        <Grid item xs={12}>
          <PricingQuoteFootNotes includedProducts={includedProductsInThisQuote || []} packageDiscount={thisQuoteDiscount || 0} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ViewQuote;
